import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./AccountProfile'));

function LoadableAccountProfile() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableAccountProfile;

